// extracted by mini-css-extract-plugin
var _1 = "qwOWd";
var _2 = "v7Eub";
var _3 = "UHgKQ";
var _4 = "V71qi";
var _5 = "FaiOx";
export { _1 as "tab", _2 as "tab--selected", _3 as "tab-content", _4 as "tabs", _5 as "tabs--full-width" }
